import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.css'

import {library} from '@fortawesome/fontawesome-svg-core'
import {faUserSecret, faPen, faTrash, faScroll, faCircleInfo, faTimes, faExternalLinkAlt, faMaximize, faAnglesLeft, faAngleDoubleLeft, faAnglesRight, faAngleDoubleRight} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(faCircleInfo, faUserSecret, faPen, faTrash, faScroll, faTimes, faExternalLinkAlt, faMaximize, faAnglesLeft, faAngleDoubleLeft, faAnglesRight, faAngleDoubleRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)

var MobileDetect = require('mobile-detect'),
    md = new MobileDetect(window.navigator.userAgent);

Vue.config.productionTip = false;
// Vue.prototype.$http = axios;
Vue.config.warnHandler = function (msg, vm, trace) {
};

export var globalStore = new Vue({
    data: {
        selectedVessel: '',
        selectedIMO: '',
        twinEngine: false,
        gasEngine: false,
        selectedEngine: '',
        availableVessels: [],
        cylCount: 0,
        tcCount: 0,
        allowNav: true,
        userLogged: false,
        userProfile: {},
        signals: {},
        reference: {},
        mapping: {},
        ehcMapping: {},
        faultMapping: {},
        units: {},
        loadDiagram: {},
        limits: {},
        type: '',
        faults: [],
        faultHistory: [],
        faultFromDate: '',
        selectFaultId: null,
        fautlToDate: '',
        dashboard: {},
        mapData: {},
        chartData: {},
        mapDate: '',
        alertDate: '',
        alertFilters: [],
        alerts: [],
        validDate: false,
        checkedDate: false,
        dateTo: '',
        loading: true,
        expectingVesselData: false,
        config: {},
        MyEvent: null,
        notificationId: null,
        available_dates: {},
        auth_token: '',
        request: null,
        requestedBeforeLogin: '',
        hasACKMaintenanceTasks: false,
        userExpirationInterval: null
    },
    methods: {
        is_mobile: function () {
            return md.mobile() != null;
        },
        checkUserExpiration: function () {
            let cookies = document.cookie.split(';')

            cookies.map((cookie) => {
                if (cookie.indexOf('account_expiration=') > -1) {
                    try {
                        let expiration_date = new Date(parseInt(cookie.split('=')[1])),
                            now = new Date();

                        if (expiration_date < now) {
                            window.$cookies.set('login', 'Your connection to the application has expired');
                            globalStore.userLogged = false;
                            window.$cookies.remove('account_expiration');
                            window.$cookies.remove('user');

                            clearInterval(this.userExpirationInterval);
                            this.userExpirationInterval = null;

                            location.reload(true);
                        }
                    } catch (e) {
                    }
                }
            })
        }
    },
    created() {
        axios.get('/config.json').then(async (response) => {
            this.config = response.data;

            await localStorage.setItem('config', JSON.stringify(response.data));

            if (this.is_mobile()) {
                window.location.href = this.config.redirect_to + "/login";
            }

        });

        this.MyEvent = new class {
            constructor() {
                this.vue = new Vue();
            }

            fire(event, data = null) {
                this.vue.$emit(event, data);
            }

            listen(event, callback) {
                this.vue.$on(event, callback);
            }
        };
    },
    computed: {
        user: function () {
            return this.userLogged
            return !window.$cookies.isKey('user')
        }
    },
    watch: {
        user: function () {
            console.log(this.user, this.userLogged);
            if (this.user){
                this.userExpirationInterval = setInterval(() => {
                    try {
                        this.checkUserExpiration();
                    } catch (e) {
                    }
                }, 1000);
            } else {
                try {
                    clearInterval(this.userExpirationInterval);
                    this.userExpirationInterval = null;
                } catch (e) {}
            }
        }
    }
});

export var vessels = new Vue({
    data: {
        vessels: {}
    }
});

new Vue({
    render: h => h(App),
    router
}).$mount('#app');


